module.exports = __webpack_public_path__ + "static/media/dustbin_icon.a3a6d691.svg";